module.exports = __webpack_public_path__ + "img/cheers.6697515c.svg";